const en = {
  common: {
    appName: 'Public Opinion Monitoring System',
    loading: 'Loading...',
    noData: 'No data',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    search: 'Search',
    export: 'Export',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    submit: 'Submit',
    reset: 'Reset',
    close: 'Close',
    all: 'All',
    total: 'Total',
    actions: 'Actions',
    status: 'Status',
    type: 'Type',
    name: 'Name',
    time: 'Time',
    operation: 'Operation',
    success: 'Success',
    failed: 'Failed',
    yes: 'Yes',
    no: 'No',
    page: 'Page',
    of: 'of',
    items: 'items',
    selectPlaceholder: 'Please select',
    inputPlaceholder: 'Please enter',
    viewOriginal: 'View Original',
  },
  nav: {
    dashboard: 'Dashboard',
    monitor: 'Monitoring',
    monitorManage: 'Monitor Management',
    monitorData: 'Data Monitoring',
    analysis: 'Analysis',
    volume: 'Volume Monitor',
    publicOption: 'Event Analysis',
    report: 'Reports',
    settings: 'Settings',
    settingsWarning: 'Warning Settings',
    settingsWarningMsg: 'Warning Messages',
    settingsPreference: 'Preferences',
    settingsUsers: 'User Management',
    settingsFeedback: 'Feedback',
  },
  login: {
    title: 'Sign In',
    subtitle: 'Public Opinion Monitoring System',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    signIn: 'Sign In',
    signingIn: 'Signing in...',
    logout: 'Sign Out',
    invalidCredentials: 'Invalid phone number or password',
  },
  dashboard: {
    title: 'Dashboard',
    todayStatus: 'Today\'s Public Opinion',
    warningAlerts: 'Warning Alerts',
    hotEvents: 'Hot Events',
    hotSearch: 'Hot Search Terms',
    leadersOpinion: 'Leaders\' Public Opinion',
    pushOpinion: 'Pushed Opinions',
    reprintQuery: 'Reprint Query',
    collection: 'Collected Posts',
    hotWeibo: 'Weibo Hot Topics',
    hotWechat: 'WeChat Hot Topics',
    hotDouyin: 'Douyin Hot Topics',
    hotBilibili: 'Bilibili Hot Topics',
    onlineUsers: 'Online Users',
    dailyReport: 'Daily Report',
    weeklyReport: 'Weekly Report',
  },
  monitor: {
    title: 'Monitor Management',
    addGroup: 'Add Group',
    editGroup: 'Edit Group',
    deleteGroup: 'Delete Group',
    addProject: 'Add Project',
    editProject: 'Edit Project',
    deleteProject: 'Delete Project',
    groupName: 'Group Name',
    projectName: 'Project Name',
    projectType: 'Project Type',
    normal: 'Normal',
    advanced: 'Advanced',
    subjectWord: 'Subject Keywords',
    characterWord: 'Character Keywords',
    eventWord: 'Event Keywords',
    regionalWord: 'Regional Keywords',
    stopWord: 'Stop Keywords',
    projectDescription: 'Description',
    selectProject: 'Please select a project from Monitor Manage',
    deleteConfirm: 'Are you sure you want to delete?',
    groupDeleteConfirm: 'Deleting this group will also delete all projects in it. Continue?',
    dataList: 'Data Monitoring',
    articleTitle: 'Article Title',
    sourceName: 'Source',
    publishTime: 'Publish Time',
    emotion: 'Emotion',
    positive: 'Positive',
    neutral: 'Neutral',
    negative: 'Negative',
    similarCount: 'Similar Count',
    sourcePlatform: 'Source Platform',
    keyword: 'Keyword',
    timeRange: 'Time Range',
    hours24: '24 Hours',
    today: 'Today',
    yesterday: 'Yesterday',
    days3: '3 Days',
    days7: '7 Days',
    days15: '15 Days',
    days30: '30 Days',
    custom: 'Custom',
    emotionFilter: 'Emotion Filter',
    sourceFilter: 'Source Filter',
    sortBy: 'Sort By',
    timeDesc: 'Time Descending',
    timeAsc: 'Time Ascending',
    similarDesc: 'Similar Count Descending',
    matchMode: 'Match Mode',
    fullText: 'Full Text',
    titleOnly: 'Title Only',
    contentOnly: 'Content Only',
    preciseFilter: 'Precise Filter',
    mergeSimilar: 'Merge Similar',
    sourcePlatforms: 'Source Platforms',
    sourcePlatformsHint: 'Select which platforms to monitor',
    platformsCount: 'platforms',
    projectPlatforms: 'Project platforms',
    sourcePlatformFilter: 'Source Platform',
    monitorDuration: 'Data Time Range',
    monitorDurationHint: 'Set the data monitoring time range, up to 1 year (365 days)',
    days: 'days',
    days365: '1 Year',
  },
  analysis: {
    title: 'Monitor Analysis',
    dataOverview: 'Data Overview',
    emotionalProportion: 'Emotion Proportion',
    planWordHit: 'Subject Word Hits',
    keywordEmotionTrend: 'Keyword Emotion Trend',
    hotEventRanking: 'Hot Event Ranking',
    highwordCloud: 'Keyword Cloud',
    keywordIndex: 'Keyword Index',
    mediaActivity: 'Media Activity Analysis',
    hotSpotRanking: 'Hot Spot Ranking',
    dataSourceDistribution: 'Data Source Distribution',
    dataSourceAnalysis: 'Data Source Analysis',
    keywordExposureRank: 'Keyword Exposure Rank',
    selfmediaVolumeRank: 'Self-Media Volume Rank',
    popularInformation: 'Popular Information',
    popularEvent: 'Popular Events',
    hotCompany: 'Hot Companies',
    hotPeople: 'Hot People',
    hotSpot: 'Hot Spots',
    relativeNews: 'Related News',
    categoryRank: 'Category Trend',
    industrialDistribution: 'Industrial Distribution',
    eventStatistics: 'Event Statistics',
    keywordEmotionStatistical: 'Keyword Emotion Statistics',
    timePeriod: 'Time Period',
    update: 'Update Analysis',
    totalArticles: 'Total Articles',
    newsCount: 'News Count',
    socialCount: 'Social Media Count',
  },
  volume: {
    title: 'Volume Monitor',
    totalVolume: 'Total Volume',
    newsVolume: 'News Volume',
    socialVolume: 'Social Volume',
    keywordEmotionStatistical: 'Keyword Emotion Statistics',
    keywordSourceDistribution: 'Keyword Source Distribution',
    keywordNewsRank: 'Keyword News Rank',
    topicClusterAnalysis: 'Topic Cluster Analysis',
    keywordEmotionTrend: 'Keyword Emotion Trend',
    highwordCloud: 'Keyword Cloud',
    keywordExposureRank: 'Keyword Exposure Rank',
    keywordCorrelationNews: 'Hot Content Cluster Rank',
    userPortraitLabel: 'User Portrait Labels',
    socialUserVolumeRank: 'Social Network User Volume Rank',
    mediaUserVolumeRank: 'Self-Media User Volume Rank',
  },
  publicOption: {
    title: 'Event Analysis',
    addEvent: 'Create Event',
    editEvent: 'Edit Event',
    deleteEvent: 'Delete Event',
    eventName: 'Event Name',
    eventKeywords: 'Event Keywords',
    eventStartTime: 'Start Time',
    eventEndTime: 'End Time',
    eventStopWords: 'Stop Words',
    reportList: 'Report List',
    reportDetail: 'Report Detail',
    backAnalysis: 'Traceability Analysis',
    eventContext: 'Event Context',
    eventTrace: 'Event Tracking',
    hotAnalysis: 'Hot Analysis',
    netizensAnalysis: 'Key Netizen Analysis',
    statistics: 'Statistics',
    propagationAnalysis: 'Propagation Analysis',
    thematicAnalysis: 'Thematic Analysis',
    unscrambleContent: 'Content Interpretation',
    judicialOpinion: 'Judicial Public Opinion',
    statusCreating: 'Creating',
    statusFailed: 'Creation Failed',
    statusSuccess: 'Created Successfully',
  },
  report: {
    title: 'Analysis Reports',
    dailyReport: 'Daily Report',
    weeklyReport: 'Weekly Report',
    monthlyReport: 'Monthly Report',
    reportName: 'Report Name',
    reportType: 'Report Type',
    reportPeriod: 'Report Period',
    reportStatus: 'Report Status',
    generating: 'Generating',
    editing: 'Editing',
    completed: 'Completed',
    failed: 'Failed',
    deleteSelected: 'Delete Selected',
    compile: 'Compile',
    viewDetail: 'View Detail',
    dataOverview: 'Data Overview',
    emotionAnalysis: 'Emotion Analysis',
    hotEventRanking: 'Hot Event Ranking',
    mediaActivity: 'Media Activity',
    selfMediaRanking: 'Self-Media Ranking',
    highWordIndex: 'High-Frequency Word Index',
    hotSpotRanking: 'Hot Spot Ranking',
    netizenWordCloud: 'Netizen Word Cloud',
    mediaWordCloud: 'Media Word Cloud',
    hotPeople: 'Hot People',
    hotSpots: 'Hot Spots',
    topicClustering: 'Topic Clustering Analysis',
    socialVRanking: 'Social Network Influencer Ranking',
  },
  settings: {
    title: 'System Settings',
    warning: {
      title: 'Warning Settings',
      warningName: 'Warning Name',
      warningWord: 'Warning Keywords',
      warningSwitch: 'Warning Switch',
      warningClassify: 'Source Type',
      warningContent: 'Warning Content',
      allContent: 'All',
      sensitiveOnly: 'Sensitive Only',
      warningMatch: 'Match Mode',
      warningDeduplication: 'Deduplication',
      warningSource: 'Warning Source',
      systemPush: 'System Push',
      emailPush: 'Email Push',
      receiveTime: 'Receive Time',
      weekendWarning: 'Weekend Warning',
      warningInterval: 'Warning Interval',
      realtime: 'Real-time',
      scheduled: 'Scheduled',
      messageList: 'Warning Messages',
      edit: 'Edit Warning',
    },
    preference: {
      title: 'Preferences',
      timeRange: 'Time Range',
      preciseFilter: 'Precise Filter',
      emotion: 'Emotion Filter',
      similar: 'Similar Articles',
      sort: 'Sort Order',
      matchMode: 'Match Mode',
      dataSource: 'Data Source',
      websiteName: 'Website Name',
      author: 'Author',
      organization: 'Organization',
      categoryLabel: 'Article Category',
      enterpriseType: 'Enterprise Type',
      highTechType: 'High-Tech Type',
      policyLabel: 'Policy',
      dataSourceType: 'Data Category',
      eventIndex: 'Event',
      industryIndex: 'Industry',
      province: 'Province',
      city: 'City',
    },
    feedback: {
      title: 'Feedback & Suggestions',
      content: 'Your feedback',
      submit: 'Submit Feedback',
    },
  },
}

export default en
